import { ContactAddressType } from '../common/ContactAddress.type'
import { validateAgePhoneCloudImportFile } from './validateAgePhoneCloudImportFile'
import { validateImportFile } from './validateImportFile'
import { validateWidefoneImportFile } from './validateWidefoneImportFile'
import { validateYealinkImportFile } from './validateYealinkImportFile'
import { validateCloudbizImportFile } from './validateCloudbizImportFile'
export const csvArrayToJson = (
  data: string[][],
  loginUserRole: number,
  ConfigUserRole: any
): ContactAddressType[] | boolean => {
  const normalizeKeys = (keys: string[]) =>
    keys.map(k => k.replace(/^\uFEFF/, '').trim())

  let rawKeys = data.shift() as string[]
  if (rawKeys.every(k => !k.trim())) {
    rawKeys = data.shift() as string[];
  }
  const keys = normalizeKeys(rawKeys)
  
  data = data.filter(row =>
  row.some(col => (col ?? "").trim() !== "")
);

  const kindOfAddress = validateImportFile(keys)

  if (kindOfAddress === 'AgePhoneAddress') {
    const resultConfirm = window.confirm('インポートするアドレス帳は、AgePhoneCloudアドレス帳です。\nよろしいですか？')
    if (resultConfirm === false) {
      return false
    }
    let result = validateAgePhoneCloudImportFile(keys)
    if (result !== "") {
      alert(result)
      return false
    }
  }
  else if (kindOfAddress === 'WidefoneAddress') {
    const resultConfirm = window.confirm('インポートするアドレス帳は、Widefoneアドレス帳です。\nよろしいですか？')
    if (resultConfirm === false) {
      return false
    }
    let result = validateWidefoneImportFile(keys)
    if (result !== "") {
      alert(result)
      return false
    }
  }
  else if (kindOfAddress === 'YealinkAddress') {
    const resultConfirm = window.confirm('インポートするアドレス帳は、Yealinkアドレス帳です。\nよろしいですか？')
    if (resultConfirm === false) {
      return false
    }
    let result = validateYealinkImportFile(keys)
    if (result !== "") {
      alert(result)
      return false
    }
  }
  else if (kindOfAddress === "CloudbizAddress") {
    const resultConfirm = window.confirm('インポートするアドレス帳は、CloudPhone Biz Pro アドレス帳です。\nよろしいですか？')
    if (!resultConfirm) return false;

    let result = validateCloudbizImportFile(keys);
    if (result !== "") {
      alert(result);
      return false;
    }
  }
  else {
    alert('連絡先ファイルの形式を判定できません。\n未対応の形式である可能性があります。')
    return false
  }

  let contactAddressList: ContactAddressType[] = []

  let line = 2; // 1行目のカラムヘッダはkeysに格納されており、dataにはカラムヘッダは含まれていない。
  let resultMandatoryCheck = ""
  for (const contactAddressData of data) {
    let workObj: any = {} as any
    let currentUserObj: ContactAddressType = {} as ContactAddressType

    contactAddressData.forEach((contactAddressItem, index) => {
      if (!contactAddressItem && index === 0) return false

      const currentKey = keys[index] as string
      //console.log(`csvArrayToJson() key=${currentKey} value=${contactAddressItem}`)
      workObj = {
        ...workObj,
        ...{ [currentKey]: contactAddressItem },
      }
    })

    // AgePhoneCloudアドレス帳の場合、Widefoneアドレス帳に変換する
    if (kindOfAddress === 'AgePhoneAddress') {
      if (workObj.phone === "") {
        // 電話番号が未設定の場合
        if (workObj.mobile !== "") {
          // モバイル電話番号が設定されている場合
          // モバイル電話番号を電話番号に設定して、モバイル電話番号は未設定とする
          currentUserObj.phone = workObj.mobile
          currentUserObj.mobilePhone = ""
        }
        else {
          currentUserObj.phone = ""
          currentUserObj.mobilePhone = ""
        }
      }
      else {
        currentUserObj.phone = workObj.phone
        currentUserObj.mobilePhone = workObj.mobile
      }
      currentUserObj.email = workObj.email
      if (loginUserRole === ConfigUserRole['カンパニー管理者']) {
        currentUserObj.category = "shared"  // 公開範囲 共有アドレス:"shared" 個人アドレス:"personal"
        currentUserObj.contactType = "020"  // 010:カンパニー内部 020:カンパニー外部
      }
      else {
        currentUserObj.category = "personal"  // 公開範囲 共有アドレス:"shared" 個人アドレス:"personal"
        currentUserObj.contactType = "020"  // 010:カンパニー内部 020:カンパニー外部
      }
      if (workObj.last_name === "") {
        resultMandatoryCheck += `\r\n${line} 行目のフィールド「last_name」は必須項目ですが値がありません。`
      }
      if (workObj.first_name === "") {
        resultMandatoryCheck += `\r\n${line} 行目のフィールド「first_name」は必須項目ですが値がありません。`
      }
      if (workObj.last_name !== "" || workObj.first_name !== "") {
        currentUserObj.contactName = workObj.last_name + workObj.first_name
        currentUserObj.firstName = workObj.first_name
        currentUserObj.lastName = workObj.last_name
      }
      else {
        if (workObj.username !== "") {
          currentUserObj.contactName = workObj.username
          currentUserObj.firstName = ""
          currentUserObj.lastName = workObj.username
        }
      }
      currentUserObj.firstNameKana = workObj.phonetic_first_name
      currentUserObj.lastNameKana = workObj.phonetic_last_name
      currentUserObj.organization = workObj.organization
      currentUserObj.department = workObj.department
      currentUserObj.position = workObj.title
      currentUserObj.telExtension = workObj.extension
      currentUserObj.altEmail = workObj.alt_email
      currentUserObj.fax = workObj.fax
      currentUserObj.postalCode = workObj.zipcode
      currentUserObj.address1 = workObj.street1
      currentUserObj.address2 = workObj.street2
      currentUserObj.city = workObj.city
      currentUserObj.prefecture = workObj.state
      currentUserObj.country = workObj.country
      // currentUserObj.site = workObj.unknown
      // currentUserObj.linkedIn = workObj.unknown
      // currentUserObj.facebook = workObj.unknown
      // currentUserObj.twitter = workObj.unknown
      // currentUserObj.skype = workObj.unknown
      // currentUserObj.slack = workObj.unknown
      // currentUserObj.github = workObj.unknown
      // currentUserObj.youtube = workObj.unknown
      // currentUserObj.tiktok = workObj.unknown
      // currentUserObj.spotify = workObj.unknown
      // currentUserObj.discord = workObj.unknown
      // currentUserObj.isFavorite = workObj.unknown
      // currentUserObj.birthday = workObj.unknown
      // currentUserObj.memo = workObj.unknown
      // currentUserObj.profileImage = workObj.unknown
      // currentUserObj.mimeType = workObj.unknown
      // currentUserObj.createdDate = workObj.unknown
      // currentUserObj.updatedDate = workObj.unknown
    }
    else if (kindOfAddress === 'WidefoneAddress') {
      if (workObj.contactName === "") {
        resultMandatoryCheck += `\r\n${line} 行目のフィールド「contactName」は必須項目ですが値がありません。`
      }
      currentUserObj = workObj
    }
    else if (kindOfAddress === "YealinkAddress") {
      if(!workObj.display_name || workObj.display_name.trim() === ""){
        resultMandatoryCheck += `\r\n${line} 行目のフィールド「display_name」は必須項目ですが値がありません。`
      }
      currentUserObj.lastName = workObj.display_name?.trim() ?? "";
      currentUserObj.contactName = workObj.display_name?.trim() ?? "";
      currentUserObj.telExtension = "";
      currentUserObj.phone = workObj.mobile_number?.trim() ?? "";
      currentUserObj.mobilePhone = workObj.office_number?.trim() ?? "";
    }

    else if (kindOfAddress === "CloudbizAddress") {
      if (!workObj["名称"] || workObj["名称"].trim() === "") {
        resultMandatoryCheck += `\r\n${line} 行目のフィールド「名称」は必須項目ですが値がありません。`;
      }
      currentUserObj.lastName = workObj["名称"]?.trim() ?? "";
      currentUserObj.contactName = workObj["名称"]?.trim() ?? "";
      currentUserObj.lastNameKana = workObj["名称カナ"]?.trim() ?? "";
      currentUserObj.memo = workObj["備考"] ?? "";

      const typeValue = workObj["内線/外線"]?.trim();
      const number = workObj["電話番号"]?.replace(/['",]/g, "").trim();

      currentUserObj.phone = typeValue === "外線" ? number : "";

      currentUserObj.telExtension = "";
    }


    //if (Object.keys(workObj).length > 0) {
    //  console.log(`csvArrayToJson() currentUserObj=${JSON.stringify(currentUserObj, null, '\t')}`)
    //}

    if (Object.keys(workObj).length > 0) {
      contactAddressList.push(currentUserObj)
    }

    line += 1;
  }

  if (resultMandatoryCheck !== "") {
    alert(resultMandatoryCheck)
    return false
  }

  return contactAddressList
}
